// extracted by css-extract-rspack-plugin
export default {"filter":"aMOtf","aggregation":"nebGj"};